import tokml from 'tokml';
import http from '../utils/http';

export default {
    async getSafras() {
        return http.get({
            url: '/safra',
            lockScreen: false,
            lockMessage: 'Buscando dados de safras'
        });
    },
    async getSafrasVigentes() {
        return http.get({
            url: '/safra/vigentes',
            lockScreen: false,
            lockMessage: 'Buscando dados de safras vigentes'
        });
    },
    async getCulturas() {
        return http.get({
            url: `/culturas`,
            lockScreen: false,
            lockMessage: 'Aguarde, buscando dados de culturas.'
        });
    },
    async getCulturasMonitoramento() {
        return http.get({
            url: `/culturas-monitoramento`,
            lockScreen: false,
            lockMessage: 'Aguarde, buscando dados de culturas.'
        });
    },
    findAlertas(filtro) {
        return http.post({
            url: '/alertas',
            data: filtro,
            lockScreen: false
        });
    },
    getQuantitativos() {
        return http.get({
            url: '/quantitativos',
            lockScreen: true
        });
    },

    getDadosCAR(codigosCAR) {
        return http.post({
            url: `/cars`,
            data: codigosCAR,
            lockScreen: true,
            lockMessage: 'Buscando CARs sobrepostos'
        });
    },

    baixarKMLdeGeometria(geoJson) {
        const kml = tokml(geoJson);
        const convertedKML =
            'application/xml;charset=utf-8,' + encodeURIComponent(kml);

        const elDownload = document.createElement('a');
        elDownload.setAttribute('href', 'data:' + convertedKML);
        elDownload.setAttribute('download', 'poligono.kml');

        document.body.appendChild(elDownload);
        elDownload.click();
        document.body.removeChild(elDownload);
    },

    buscarGejsonPorCamadaPonto(camada, ponto) {
        return http.post({
            url: '/geoserver/feature',
            data: { camada, ponto },
            lockScreen: false
        });
    },

    baixarArquivo(url) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({ url: `${url}`, responseType: 'blob' })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarTotalizadores() {
        return http.get({
            url: '/totalizador',
            lockScreen: false
        });
    },
    
    buscarTotalizadoresArgentina() {
        return http.get({
            url: '/totalizador/ar',
            lockScreen: false
        });
    }
};
